import React from 'react'

import isValidArray from 'lib/functions/isValidArray'
import Facility from 'client/components/Facilities/Facility'
import { MappedClusteredFacilities } from 'src/effects/Availability/facilitiesMapper'

export const MAX_FACILITIES_FEATURED = 4

interface FacilitiesProps {
  facilities: MappedClusteredFacilities[]
}

const Facilities = ({ facilities = [] }: FacilitiesProps) => {
  const featured = facilities
    .filter(facility => facility.description.toLowerCase() === 'featured')
    .flatMap(facility => facility.facilities)
    .slice(0, MAX_FACILITIES_FEATURED)

  if (!isValidArray(featured)) {
    return null
  }

  return (
    <ul>
      {featured.map(facility => (
        <li key={facility.name}>
          <Facility icon={facility.icon} name={facility.name} />
        </li>
      ))}
    </ul>
  )
}

export default Facilities
